import { render, staticRenderFns } from "./resetPasswordAffiliate.vue?vue&type=template&id=5f6c2760&lang=pug"
import script from "./resetPasswordAffiliate.vue?vue&type=script&lang=js"
export * from "./resetPasswordAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports